import { isBettoHistoryTenant } from "@pages/profile-v2/betto/shared/bettoHistoryStyles";
import styled from "styled-components";

const ContentWrapper = styled.div`
	display: flex;
	padding: ${isBettoHistoryTenant ? "0" : "10px"};
	flex-direction: column;
	align-items: stretch;
	gap: ${isBettoHistoryTenant ? "0" : "10px"};
	flex: 1 0 0;
	border-radius: ${isBettoHistoryTenant ? "12px" : "20px"};
	background: ${isBettoHistoryTenant ? "transparent" : "var(--profile-page-wrapper-bg)"};

	@media (min-width: 1024px) {
		padding: ${isBettoHistoryTenant ? "0" : "10px 20px"};
	}
`;

export { ContentWrapper };
